<template>
    <span>
        <span v-if="decisonType=='pass'">
            <b-icon  class="is-small" type="is-primary" pack="far" icon="check-circle"></b-icon>
        </span>
        <span v-else-if="decisonType=='fail'">
            <b-icon  class="is-small" type="is-danger" pack="far" icon="times-circle"></b-icon>
        </span>
    </span>
</template>

<script>
export default {
    props: ["decisonType"],
}
</script>
